<div class="mx-auto w-full max-w-5xl px-4 py-8 sm:px-6 sm:py-10">
  <div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <p class="mb-2 text-xs font-bold uppercase tracking-[0.16em] text-primary">Application record</p>
      <h2 class="font-heading text-2xl font-bold tracking-tight text-foreground sm:text-3xl">My application form</h2>
      <p class="mt-2 text-sm text-muted-foreground">Review or download a copy of your submitted membership information.</p>
    </div>
    <button hlmBtn size="lg" (click)="downloadPDF()" class="self-start sm:self-auto">
      <ng-icon name="lucideDownload" />
      Download PDF
    </button>
  </div>
  <div class="overflow-hidden rounded-2xl border border-border bg-card shadow-sm">
    <div class="brand-gradient-bar h-1.5"></div>
    <app-membership-form-data />
  </div>
</div>
